import {
    ApiService,
    FeatureService,
    LoggerService,
    MenuService,
    NetworkService,
    URLS,
    INFRASTRUCTURE_URLS,
    ZITI_URLS,
    ZITI_BETA_LIST_ROUTES,
    CustomerService,
    ShareService,
    AgentService
} from '@netfoundry-ui/shared/services';
import { Router } from '@angular/router';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { Environment, ENVIRONMENT, Network, NetworkV2, Organization, Tenant, Customer, Share } from '@netfoundry-ui/shared/model';
import { NETWORK_SERVICE, NetworkServiceV2 } from '@netfoundry-ui/shared/apiv2';
import { NetworkUpgradeService } from '@netfoundry-ui/feature-network-upgrade';
import { Auth0Service, AuthorizationService, IamService } from '@netfoundry-ui/shared/authorization';
import { OrganizationPromptComponent } from '@netfoundry-ui/feature/form/organization-prompt';
import { MatDialog } from '@angular/material/dialog';
import { V2NetworkCreationFormComponent } from '@netfoundry-ui/feature/form/v2-network-creation-form';
import { Inject, Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { isEmpty } from 'lodash';
import { TicketFormComponent } from '@netfoundry-ui/feature/form/ticket-form';
import { ConsoleTourComponent } from '@netfoundry-ui/feature/console-tour';
import { ZendeskWidgetService } from '@netfoundry-ui/shared/services';


export const ZAC_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    // Single dashboard entry. `dashboardSwitch` tells doNavAction (side-navigator.component)
                    // to resolve the destination from the "Enable Beta Features" toggle: the redesigned
                    // Overview when on, the legacy Dashboard when off. selectedRoutes covers both so the
                    // item highlights on either URL. Both routes stay reachable directly by URL.
                    label: 'Dashboard',
                    route: INFRASTRUCTURE_URLS.DASHBOARD,
                    dashboardSwitch: true,
                    iconClass: 'icon-Icon_Dash',
                    selectedRoutes: [INFRASTRUCTURE_URLS.DASHBOARD, INFRASTRUCTURE_URLS.OVERVIEW],
                    isMOPView: true,
                    requiresNetwork: true,
                },
            ],
        },
        {
            label: 'Core Components',
            menuItems: [
                {
                    // identitiesSwitch: doNavAction picks the destination from the beta toggle;
                    // selectedRoutes lists both URLs so the item highlights on either.
                    label: 'Identities',
                    route: ZITI_URLS.ZITI_IDENTITIES,
                    identitiesSwitch: true,
                    iconClass: 'icon-endpoints',
                    selectedRoutes: [ZITI_URLS.ZITI_IDENTITIES, ZITI_URLS.ZITI_IDENTITIES_LIST, ZITI_URLS.ZITI_RECIPES, ZITI_URLS.ZITI_TERMINATORS, ZITI_URLS.ZITI_TERMINATORS_LIST, URLS.ZITIENDPOINTS],
                    requiresProvision: true,
                },
                {
                    label: 'Services',
                    route: ZITI_URLS.ZITI_SERVICES,
                    betaListSwitch: true,
                    iconClass: 'icon-services',
                    selectedRoutes: [
                        ZITI_URLS.ZITI_SERVICES,
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_SERVICES],
                        ZITI_URLS.ZITI_CONFIGS,
                        ZITI_URLS.ZITI_CONFIG_TYPES,
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_CONFIGS],
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_CONFIG_TYPES],
                        URLS.ZITISERVICES,
                    ],
                    requiresProvision: true,
                },
                {
                    label: 'Routers',
                    route: ZITI_URLS.ZITI_ROUTERS,
                    betaListSwitch: true,
                    iconClass: 'icon-routers',
                    selectedRoutes: [
                        ZITI_URLS.ZITI_ROUTERS,
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_ROUTERS],
                        ZITI_URLS.ZITI_TRANSIT_ROUTERS,
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_TRANSIT_ROUTERS],
                    ],
                    requiresProvision: true,
                },
                {
                    label: 'IPsec Tunnelers',
                    route: URLS.IPSEC_TUNNELERS,
                    betaListSwitch: true,
                    iconClass: 'icon-ipsec-tunnelers',
                    selectedRoutes: [URLS.IPSEC_TUNNELERS, URLS.IPSEC_TUNNELERS_LIST],
                    isMOPView: true,
                    requiresProvision: true,
                },
            ],
        },
        {
            label: 'Access Management',
            menuItems: [
                {
                    label: 'Policies',
                    route: ZITI_URLS.ZITI_SERVICE_POLICIES,
                    betaListSwitch: true,
                    iconClass: 'icon-Policies',
                    selectedRoutes: [
                        ZITI_URLS.ZITI_SERVICE_POLICIES,
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_SERVICE_POLICIES],
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_ROUTER_POLICIES],
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_SERVICE_ROUTER_POLICIES],
                        ZITI_URLS.ZITI_ROUTER_POLICIES,
                        ZITI_URLS.ZITI_SERVICE_ROUTER_POLICIES,
                        URLS.ZITIPOLICIES,
                        URLS.ZITIAPPS
                    ],
                    requiresProvision: true,
                },
                {
                    label: 'Posture Checks',
                    route: ZITI_URLS.ZITI_POSTURE_CHECKS,
                    betaListSwitch: true,
                    iconClass: 'icon-posturechecks',
                    selectedRoutes: [ZITI_URLS.ZITI_POSTURE_CHECKS, ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_POSTURE_CHECKS]],
                    requiresProvision: true,
                },
                {
                    label: 'Authentication',
                    route: ZITI_URLS.ZITI_CERT_AUTHORITIES,
                    betaListSwitch: true,
                    iconClass: 'icon-CAs',
                    selectedRoutes: [
                        ZITI_URLS.ZITI_CERT_AUTHORITIES,
                        ZITI_URLS.ZITI_AUTH_POLICIES,
                        ZITI_URLS.ZITI_JWT_SIGNERS,
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_CERT_AUTHORITIES],
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_AUTH_POLICIES],
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_JWT_SIGNERS],
                    ],
                    requiresProvision: true,
                },
                {
                    label: 'Sessions',
                    route: ZITI_URLS.ZITI_SESSIONS,
                    betaListSwitch: true,
                    iconClass: 'icon-time',
                    selectedRoutes: [
                        ZITI_URLS.ZITI_SESSIONS,
                        ZITI_URLS.ZITI_API_SESSIONS,
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_SESSIONS],
                        ZITI_BETA_LIST_ROUTES[ZITI_URLS.ZITI_API_SESSIONS],
                    ],
                    requiresProvision: true,
                },
                {
                    label: 'Integrations',
                    route: URLS.SCIM,
                    betaListSwitch: true,
                    iconClass: 'icon-integrations',
                    selectedRoutes: [URLS.SCIM, URLS.SCIM_LIST],
                    isMOPView: true,
                    requiresNetwork: true,
                    requiresProvision: true,
                }
            ],
        },
        {
            label: 'Visibility',
            menuItems: [
              {
                  label: 'Metrics',
                  route: INFRASTRUCTURE_URLS.METRICS,
                  iconClass: 'icon-AnalyticsReports',
                  selectedRoutes: [INFRASTRUCTURE_URLS.METRICS],
                  isMOPView: true,
                  requiresProvision: true,
              },
              {
                  // Beta-only: groups services created from traffic with their configs/policies/identities.
                  // Hidden for non-beta users (betaOnly), matching the beta-gated route.
                  label: 'Microsegments',
                  route: URLS.MICROSEGMENTS,
                  iconClass: 'icon-microsegments-flow',
                  selectedRoutes: [URLS.MICROSEGMENTS],
                  betaOnly: true,
                  requiresProvision: true,
              },
              {
                  label: 'Events',
                  route: URLS.MANAGEMENT_EVENTS,
                  betaListSwitch: true,
                  iconClass: 'icon-Icon_Events',
                  selectedRoutes: [URLS.MANAGEMENT_EVENTS, URLS.MANAGEMENT_EVENTS_LIST],
                  isMOPView: true,
                  requiresNetwork: true,
              },
              {
                  label: 'Processes',
                  route: URLS.PROCESS_EXECUTIONS,
                  betaListSwitch: true,
                  iconClass: 'icon-Processes',
                  selectedRoutes: [URLS.PROCESS_EXECUTIONS, URLS.PROCESS_EXECUTIONS_LIST],
                  isMOPView: true,
                  requiresNetwork: true,
              },
              {
                  label: 'Alerts',
                  route: URLS.ALERTS,
                  iconClass: 'icon-Bell',
                  selectedRoutes: [URLS.ALERTS],
                  requiresNetwork: true,
                  supportOnly: true,
              },
            ],
        },
        {
          label: 'Infrastructure',
          menuItems: [
            {
              label: 'Managed Components',
              route: URLS.NETWORK_CONTROLLERS,
              betaListSwitch: true,
              iconClass: 'icon-controllers',
              selectedRoutes: [
                URLS.NETWORK_CONTROLLERS,
                URLS.NETWORK_CONTROLLERS_LIST,
                INFRASTRUCTURE_URLS.ROUTERS,
                INFRASTRUCTURE_URLS.MANAGED_ROUTERS_LIST,
                URLS.ALLOCATED_IPS,
                URLS.ALLOCATED_IPS_LIST,
              ],
              isMOPView: true,
              requiresNetwork: true,
            },
            {
              label: 'Settings',
              route: INFRASTRUCTURE_URLS.SETTINGS,
              iconClass: 'icon-OrgSettings',
              selectedRoutes: [
                INFRASTRUCTURE_URLS.SETTINGS,
                INFRASTRUCTURE_URLS.SETTINGS_AI_ASSISTANT,
                INFRASTRUCTURE_URLS.SETTINGS_FIREWALL_INFO,
              ],
              isMOPView: true,
              requiresNetwork: true,
            },
            {
              label: 'Operations',
              route: INFRASTRUCTURE_URLS.OPERATIONS,
              iconClass: 'icon-StatusGear',
              selectedRoutes: [
                INFRASTRUCTURE_URLS.OPERATIONS,
                INFRASTRUCTURE_URLS.OPERATIONS_UPGRADES,
                INFRASTRUCTURE_URLS.OPERATIONS_BACKUPS,
                INFRASTRUCTURE_URLS.OPERATIONS_SUPPORT_INFO,
              ],
              isMOPView: true,
              requiresNetwork: true,
              supportOnly: true,
            },
          ],
        },
    ],
    app: 'networks',
};

export const ORGANIZATION_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    label: 'Users',
                    route: URLS.USERS,
                    betaListSwitch: true,
                    iconClass: 'icon-ManageUsers',
                    selectedRoutes: [
                        URLS.USERS,
                        URLS.USERS_LIST,
                        URLS.USER_ROLES,
                        URLS.USER_ROLES_LIST,
                        URLS.ORGANIZATION_ROLES,
                        URLS.MANAGE_INVITATIONS,
                        URLS.ROLE_TEMPLATES,
                        URLS.ROLE_TEMPLATES_LIST,
                        URLS.CLOUD_ZITI_USERS,
                        URLS.CLOUD_ZITI_INVITATIONS,
                    ],
                },
                {
                    label: 'API Accounts',
                    route: URLS.TOKENS,
                    betaListSwitch: true,
                    iconClass: 'icon-ManageAPIAccounts',
                    selectedRoutes: [URLS.TOKENS, URLS.TOKENS_LIST],
                },
                {
                    label: 'Stored Secrets',
                    route: URLS.STORED_SECRETS,
                    betaListSwitch: true,
                    iconClass: 'icon-posturechecks',
                    selectedRoutes: [URLS.STORED_SECRETS, URLS.STORED_SECRETS_LIST],
                },
                {
                    label: 'Reporting and Analytics',
                    route: URLS.NETWORK_GROUP_SUMMARY,
                    iconClass: 'icon-AnalyticsReports',
                    selectedRoutes: [URLS.NETWORK_GROUP_SUMMARY],
                    mopV7Only: true
                },
                {
                    label: 'Billing Management',
                    route: URLS.ORG_PAYMENT_PROFILE,
                    iconClass: 'icon-ManageBilling',
                    selectedRoutes: [
                        URLS.ORG_PAYMENT_PROFILE,
                        URLS.ORG_ACCOUNT_DETAILS,
                        URLS.ORG_BILLING_SUBSCRIPTIONS,
                        URLS.ORG_BILLING_SUBSCRIPTION_OVERAGES,
                        URLS.ORG_BILLING_SUBSCRIPTION_OVERAGES,
                    ],
                    enterpriseOnly: true,
                },
                {
                    label: 'Billing Management',
                    route: URLS.PAYMENT_PROFILE,
                    iconClass: 'icon-ManageBilling',
                    selectedRoutes: [
                        URLS.PAYMENT_PROFILE,
                        URLS.ACCOUNT_DETAILS,
                        URLS.BILLING_SUBSCRIPTION_OVERAGES,
                        URLS.BILLING_SUBSCRIPTION_OVERAGES,
                        URLS.BILLING_SUBSCRIPTION_USAGE_REPORT,
                    ],
                    mopV7Only: true,
                    enterpriseOnly: true
                },
                {
                    label: 'Organizational Settings',
                    route: URLS.ORG_SETTINGS,
                    iconClass: 'icon-OrgSettings',
                    selectedRoutes: [URLS.SETTINGS],
                    czV8Only: true,
                    id: 'org-settings-new'
                },
                {
                    label: 'Organizational Settings',
                    route: URLS.SETTINGS,
                    iconClass: 'icon-OrgSettings',
                    selectedRoutes: [URLS.SETTINGS],
                    mopV7Only: true,
                    id: 'org-settings'
                },
                {
                    label: 'Manage Organizations',
                    route: URLS.ORGANIZATIONS,
                    betaListSwitch: true,
                    iconClass: 'icon-ManageOrg',
                    selectedRoutes: [URLS.ORGANIZATIONS, URLS.ORGANIZATIONS_LIST],
                },
                {
                    label: 'OIDC Management',
                    route: URLS.OIDC_AUDIENCES,
                    betaListSwitch: true,
                    iconClass: 'icon-CAs',
                    selectedRoutes: [URLS.OIDC_AUDIENCES, URLS.OIDC_AUDIENCES_LIST],
                },
            ],
        },
    ],
    app: 'organization',
};

export const NETWORKS_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    label: 'Dashboard',
                    route: URLS.V7DASHBOARD,
                    iconClass: 'icon-Icon_Dash',
                    selectedRoutes: [URLS.V7DASHBOARD],
                    requiresProvision: true,
                },
            ],
        },
        {
            label: 'Core Components',
            menuItems: [
                {
                    label: 'Identities',
                    sublabel: '(Endpoints)',
                    route: URLS.ZITIENDPOINTS,
                    iconClass: 'icon-endpoints',
                    selectedRoutes: [URLS.ZITIENDPOINTS],
                    className: 'ziti-identities-nav-item',
                    requiresProvision: true,
                },
                {
                    label: 'Services',
                    route: URLS.ZITISERVICES,
                    iconClass: 'icon-services',
                    selectedRoutes: [URLS.ZITISERVICES, URLS.ZITICONFIGS, URLS.ZITICONFIGTYPES],
                    className: 'ziti-services-nav-item',
                    requiresProvision: true,
                },
                {
                    label: 'Edge Routers',
                    route: URLS.ZITIROUTERS,
                    iconClass: 'icon-routers',
                    selectedRoutes: [URLS.ZITIROUTERS],
                    requiresProvision: true,
                },
                {
                    label: 'IPsec Tunnelers',
                    route: URLS.IPSEC_TUNNELERS,
                    betaListSwitch: true,
                    iconClass: 'icon-ipsec-tunnelers',
                    selectedRoutes: [URLS.IPSEC_TUNNELERS, URLS.IPSEC_TUNNELERS_LIST],
                    isMOPView: true,
                    requiresProvision: true,
                },
            ],
        },
        {
            label: 'Access Management',
            menuItems: [
                {
                    label: 'Policies',
                    route: URLS.ZITIAPPS,
                    iconClass: 'icon-Policies',
                    sublabel: '(AppWANs)',
                    selectedRoutes: [URLS.ZITIAPPS, URLS.ZITI_SERVICE_ER_POLICIES, URLS.ZITIPOLICIES],
                    className: 'ziti-policies-nav-item',
                    requiresProvision: true,
                },
                {
                    label: 'Posture Checks',
                    route: URLS.POSTURE_CHECKS,
                    iconClass: 'icon-posturechecks',
                    selectedRoutes: [URLS.POSTURE_CHECKS],
                    requiresProvision: true,
                },
            ],
        },
        {
            label: 'Visibility',
            menuItems: [
                {
                    label: 'Attribute Explorer',
                    route: URLS.ATTRIBUTES_EXPLORER,
                    iconClass: 'icon-AttributeExplorer',
                    selectedRoutes: [URLS.ATTRIBUTES_EXPLORER],
                    requiresProvision: true,
                },
                {
                    label: 'Metrics',
                    route: URLS.METRICS,
                    iconClass: 'icon-AnalyticsReports',
                    selectedRoutes: [URLS.METRICS],
                    requiresProvision: true,
                },
                {
                    label: 'Events',
                    route: URLS.MANAGEMENT_EVENTS,
                    betaListSwitch: true,
                    iconClass: 'icon-Icon_Events',
                    selectedRoutes: [URLS.MANAGEMENT_EVENTS, URLS.MANAGEMENT_EVENTS_LIST],
                    requiresNetwork: true,
                },
                 {
                    label: 'Processes',
                    route: URLS.PROCESS_EXECUTIONS,
                    betaListSwitch: true,
                    iconClass: 'icon-Processes',
                    selectedRoutes: [URLS.PROCESS_EXECUTIONS, URLS.PROCESS_EXECUTIONS_LIST],
                    requiresNetwork: true,
                },
            ],
        },
        {
            label: 'Management',
            menuItems: [
                {
                    label: 'Integrations',
                    route: URLS.SUBSCRIPTIONS,
                    iconClass: 'icon-integrations',
                    selectedRoutes: [URLS.SUBSCRIPTIONS],
                    requiresProvision: true,
                },
                {
                    label: 'Authentication',
                    route: URLS.ZITI_CERTIFICATE_AUTHORITIES,
                    iconClass: 'icon-CAs',
                    selectedRoutes: [URLS.ZITI_CERTIFICATE_AUTHORITIES],
                    requiresProvision: true,
                },
                {
                    label: 'Network Infrastructure',
                    route: URLS.NETWORK_CONTROLLERS,
                    betaListSwitch: true,
                    iconClass: 'icon-controllers',
                    selectedRoutes: [URLS.NETWORK_CONTROLLERS, URLS.NETWORK_CONTROLLERS_LIST],
                },
                {
                    label: 'Networks',
                    route: URLS.NETWORKS_COMBINED,
                    betaListSwitch: true,
                    iconClass: 'icon-ManageNetworks',
                    selectedRoutes: [URLS.NETWORKS_COMBINED, URLS.OLD_NETWORK_LIST, URLS.NETWORK_GROUPS],
                },

            ],
        },
    ],
};

export const FRONTDOOR_NAVIGATOR = {
    groups: [
        {
            label: 'Share Configuration',
            menuItems: [
                {
                    // v1 accounts only — hideMenuItem() hides URLS.FRONTDOOR for zrok2
                    // and hides the HTTP/TCP/IPsec entries below for v1, so exactly one
                    // of the two shapes renders.
                    label: 'Shares',
                    route: URLS.FRONTDOOR,
                    iconClass: 'icon-BrowZer',
                    selectedRoutes: [URLS.FRONTDOOR],
                    requiresAgent: true,
                },
                {
                    label: 'HTTP',
                    route: URLS.FRONTDOOR_HTTP,
                    iconClass: 'icon-BrowZer',
                    selectedRoutes: [URLS.FRONTDOOR_HTTP],
                    requiresAgent: true,
                },
                {
                    label: 'TCP',
                    route: URLS.FRONTDOOR_TCP,
                    iconClass: 'icon-network-wired',
                    selectedRoutes: [URLS.FRONTDOOR_TCP],
                    requiresAgent: true,
                },
                {
                    label: 'IPSec',
                    route: URLS.FRONTDOOR_IPSEC_SHARES,
                    iconClass: 'icon-ipsec-tunnelers',
                    selectedRoutes: [URLS.FRONTDOOR_IPSEC_SHARES],
                    requiresAgent: true,
                },
            ],

        },
        {
            label: 'Host Configuration',
            menuItems: [
                {
                    label: 'Agents',
                    route: URLS.FRONTDOOR_AGENTS,
                    iconClass: 'icon-endpoints',
                    selectedRoutes: [URLS.FRONTDOOR_AGENTS],
                    requiresAgent: true,

                },
                    {
                    label: 'Frontends',
                    route: URLS.FRONTDOOR_FRONTENDS,
                    iconClass: 'icon-ManageAPIAccounts',
                    selectedRoutes: [URLS.FRONTDOOR_FRONTENDS],
                    requiresAgent: true,
                },
                // Namespaces and Authentication moved to tabs on the HTTP shares page;
                // Certificates to a tab on the TCP shares page; IPSec Tunnels to a tab
                // on the IPSec shares page.
            ],
        },
        {
            label: 'Visibility',
            menuItems: [
                {
                    label: 'Process Log',
                    route: URLS.FRONTDOOR_PROCESS_EXECUTIONS,
                    iconClass: 'icon-Policies',
                    selectedRoutes: [URLS.FRONTDOOR_PROCESS_EXECUTIONS],
                    requiresAgent: true,
                },
                // Health Checks moved to a tab on the HTTP shares page.
                // {
                //     label: 'Metrics',
                //     route: URLS.FRONTDOOR_METRICS,
                //     iconClass: 'icon-AnalyticsReports',
                //     selectedRoutes: [URLS.FRONTDOOR_METRICS],
                //     requiresAgent: true,
                // },
            ],
        },
    ],
    app: 'frontdoor',
};

/**
 * The FD sub-app: Frontdoor on the v3 API. It sits beside FRONTDOOR_NAVIGATOR
 * rather than inside it because the two read different APIs and the v1/v2 one is on its way out.
 */
export const FD_NAVIGATOR = {
    groups: [
        {
            // No title, so no label span either: an empty one leaves a gap above the Dashboard entry.
            label: '',
            hideLabel: true,
            menuItems: [
                {
                    label: 'Dashboard',
                    route: URLS.FD_DASHBOARD,
                    // The template draws faIcon in place of iconClass; the empty iconClass keeps the item's type in line.
                    iconClass: '',
                    faIcon: faChartLine,
                    selectedRoutes: [URLS.FD_DASHBOARD],
                },
            ],
        },
        {
            label: 'Share Configuration',
            menuItems: [
                {
                    // Both tabs, because the nav matches the url exactly. HTTP, TCP and IPSec each hide on a
                    // network without their extension: see SideNavigatorComponent.hideMenuItem.
                    label: 'HTTP',
                    route: URLS.FD_HTTP_SHARES,
                    iconClass: 'icon-fd-http-share',
                    selectedRoutes: [URLS.FD_HTTP_SHARES, URLS.FD_DOMAIN_NAMES],
                },
                {
                    label: 'TCP',
                    route: URLS.FD_TCP_SHARES,
                    iconClass: 'icon-fd-tcp-share',
                    selectedRoutes: [URLS.FD_TCP_SHARES],
                },
                {
                    // Its own section beside TCP, not a row under it, because it carries a Shares
                    // listing of its own as well as the tunnels.
                    label: 'IPSec',
                    route: URLS.FD_IPSEC,
                    iconClass: 'icon-fd-ipsec-share-mono',
                    selectedRoutes: [URLS.FD_IPSEC],
                },
            ],
        },
        {
            // Its own group rather than a third entry above: an agent is the host a share runs on,
            // not another kind of share.
            label: 'Infrastructure',
            menuItems: [
                {
                    label: 'Agents',
                    route: URLS.FD_AGENTS,
                    iconClass: 'icon-endpoints',
                    selectedRoutes: [URLS.FD_AGENTS],
                },
            ],
        },
        {
            // What the frontdoor did, not what it is configured to do: read after a change.
            label: 'Visibility',
            menuItems: [
                {
                    // Certificate expiry alerts, read from the alerting service. Not support-only like the
                    // network Alerts page: an expiring certificate is the account holder's to act on.
                    label: 'Alerts',
                    route: URLS.FD_ALERTS,
                    iconClass: 'icon-Bell',
                    selectedRoutes: [URLS.FD_ALERTS],
                },
                {
                    label: 'Processes',
                    route: URLS.FD_PROCESSES,
                    iconClass: 'icon-Processes',
                    selectedRoutes: [URLS.FD_PROCESSES],
                },
                {
                    // Every change to the frontdoor's resources. Hidden without the audit read grant:
                    // see SideNavigatorComponent.hideMenuItem.
                    label: 'Audit',
                    route: URLS.FD_AUDIT_EVENTS,
                    iconClass: 'icon-Icon_Events',
                    selectedRoutes: [URLS.FD_AUDIT_EVENTS],
                },
            ],
        },
        {
            label: 'System',
            menuItems: [
                {
                    // Both tabs, because the nav matches the url exactly.
                    label: 'Settings',
                    route: URLS.FD_SETTINGS,
                    iconClass: 'icon-OrgSettings',
                    selectedRoutes: [URLS.FD_SETTINGS, URLS.FD_SETTINGS_AI_ASSISTANT],
                },
                {
                    // Ingresses and network extensions, one tab each, for NetFoundry support. Hidden without ingress
                    // read or the extensions grant: see SideNavigatorComponent.hideMenuItem.
                    label: 'Operations',
                    route: URLS.FD_OPERATIONS_MANAGEMENT,
                    iconClass: 'icon-StatusGear',
                    selectedRoutes: [URLS.FD_OPERATIONS_HTTP, URLS.FD_OPERATIONS_MTLS, URLS.FD_OPERATIONS_MANAGEMENT],
                    supportOnly: true,
                },
            ],
        },
    ],
    app: 'fd',
};

export const SUPPORT_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    label: 'Support Hub',
                    link: 'https://support.netfoundry.io/hc/en-us',
                    iconClass: 'icon-hub',
                },
                {
                    label: 'Submit A Ticket',
                    action: 'openTicket',
                    iconClass: 'icon-hub',
                },
                {
                    label: 'Inline Help',
                    action: 'openSupport',
                    iconClass: 'icon-InlineHelp',
                },
                {
                    label: 'Console Tour',
                    action: 'openTour',
                    iconClass: 'icon-tour',
                },
                {
                    label: "What's New",
                    link: 'https://support.netfoundry.io/hc/en-us/sections/360008342332-Tech-Bulletins',
                    iconClass: 'icon-WhatsNew',
                },
                {
                    label: 'Getting Started',
                    route: URLS.GETTING_STARTED,
                    iconClass: 'icon-QuickStart',
                    selectedRoutes: [URLS.GETTING_STARTED],
                    class: 'getting-started-nav'
                }
            ],
        },
    ],
    app: 'support',
};

export const SUPPORT_OPERATIONS_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    label: 'Stage/Upgrade',
                    route: URLS.SUPPORT_OPERATIONS,
                    iconClass: 'icon-routers',
                    selectedRoutes: [URLS.SUPPORT_OPERATIONS],
                    requiresNetwork: true,
                },
            ],
        },
    ],
    app: 'support_operations',
};

export const ON_PREM_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    label: 'Service Accounts',
                    route: URLS.ON_PREM,
                    betaListSwitch: true,
                    iconClass: 'icon-routers',
                    selectedRoutes: [URLS.ON_PREM, URLS.ON_PREM_LIST],
                    requiresNetwork: false,
                },
            ],
        },
    ],
    app: 'on_prem',
};

export const CUSTOMERS_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    label: 'Customers',
                    route: URLS.CUSTOMERS,
                    betaListSwitch: true,
                    iconClass: 'icon-customer',
                    selectedRoutes: [URLS.CUSTOMERS, URLS.CUSTOMERS_LIST],
                },
            ],
        },
        {
            label: '',
            menuItems: [
                {
                    label: 'Customer Processes',
                    route: URLS.CUSTOMER_PROCESS_EXECUTIONS,
                    betaListSwitch: true,
                    iconClass: 'icon-Processes',
                    selectedRoutes: [URLS.CUSTOMER_PROCESS_EXECUTIONS, URLS.CUSTOMER_PROCESS_EXECUTIONS_LIST],
                },
            ],
        },
    ],
    app: 'customers',
};

export const SUPER_NAVIGATOR = {
    groups: [
        {
            label: '',
            menuItems: [
                {
                    label: 'Manage Users',
                    route: URLS.USER,
                    iconClass: 'icon-ManageUsers',
                    selectedRoutes: [URLS.USER],
                },
            ],
        },
    ],
    app: 'super',
};

export const BILLING_NAVIGATOR = {
    groups: [
        {
            label: ' ',
            menuItems: [
                {
                    label: 'Billing Dashboard',
                    route: URLS.PAYMENT_PROFILE,
                    iconClass: 'icon-ManageBilling',
                    selectedRoutes: [
                        URLS.BILLING_DASHBOARD,
                        URLS.BILLING_PAYMENT_PROFILE,
                        URLS.BILLING_ACCOUNT_DETAILS,
                        URLS.APP_BILLING_SUBSCRIPTIONS,
                        URLS.APP_BILLING_SUBSCRIPTION_OVERAGES,
                        URLS.APP_BILLING_SUBSCRIPTION_USAGE,
                        URLS.APP_BILLING_SUBSCRIPTION_USAGE_REPORT,
                    ],
                },
            ],
            headerBuffer: true,
            selfServiceOnly: true,
        },
    ],
    app: 'billing',
};

@Injectable({ providedIn: 'root' })
export class SideNavigatorService {
    public currentNetwork: any = {};
    public currentNav: any = this.featureService.isCloudZiti ? ZAC_NAVIGATOR : NETWORKS_NAVIGATOR;
    public disableMainNav = false;
    public networkProvisioning = false;
    public area = '';
    public open = false;
    public allNetworks: any = [];
    public upgradeableNetworks = 0;
    public currentSubscription: any = {};
    public isSelfService = false;
    public selfServiceBilling = false;
    public isSelfServiceTeamsTier = false;
    public currentTenant: any;
    public currentOrganization: any = {};
    public tenantId: any;
    public organizationId: any;
    public currentCustomer: any;
    public currentShare: any;
    public shareId: any;
    public customerId: any;
    public customers: any = [];
    public customerMap: any = {};
    public tenants: any = [];
    public organizations: any = [];
    public shares: any = [];
    public tenantMap: any = {};
    public organizationMap: any = {};
    public networksV6: any = [];
    public networksV7: any = [];
    public selectedNavItem: any = {};
    public frontdoorId: string | undefined;
    public requiresAgent = false;
    public envs;
    public isV2;
    public frontdoorReady$ = new ReplaySubject<void>(1);

    dialogRef: any;

    constructor(
        private logger: LoggerService,
        private router: Router,
        private apiService: ApiService,
        private agentService: AgentService,
        private featureService: FeatureService,
        private shareService: ShareService,
        private iamService: IamService,
        private menuService: MenuService,
        private networkUpgradeService: NetworkUpgradeService,
        private authorizationService: AuthorizationService,
        private dialogForm: MatDialog,
        private networkService: NetworkService,
        private customerService: CustomerService,
        private zendeskService: ZendeskWidgetService,
        private auth0Service: Auth0Service,
        @Inject(NETWORK_SERVICE) private networkServiceV2: NetworkServiceV2,
        @Inject(ENVIRONMENT) private environment: Environment
    ) {
        this.apiService.currentTenant.subscribe((tenant) => {
            this.tenantId = tenant.id;
            this.currentTenant = tenant;
            this.loadTenants();
            // Re-evaluate on every tenant change. A one-shot read of localStorage at
            // construction time can run against a stale or missing org, and switching
            // orgs would otherwise keep the previous org's answer.
            this.loadShares(tenant.id);
        });
        this.apiService.currentOrganization.subscribe((organization) => {
            this.organizationId = organization.id;
            this.currentOrganization = organization || {};
            this.loadOrganizations();
        });
        this.apiService.currentCustomer.subscribe((customer) => {
            this.currentCustomer = customer;
        });

        this.apiService.currentShare.subscribe((share) => {
            this.currentShare = share;
        });

        this.apiService.currentPermissions.subscribe((permissions) => {
            if (!isEmpty(permissions) && this.customers.length === 0) {
                this.loadCustomers();
            }
        });
        this.apiService.currentNetwork.subscribe((network) => {
            this.currentNetwork = network;
            // Don't fetch the network list pre-login — the initial BehaviorSubject
            // emission fires before auth completes and trips silent-refresh.
            if (this.auth0Service?.authenticated) {
                this.initNetworks();
            }
            this.updateAppNavigator();

            const n2 = network as unknown as NetworkV2;
            this.disableMainNav = !n2?.status || n2?.status === 'PROVISIONING' || n2?.status === 'SUSPENDED';
            this.networkProvisioning = n2?.status === 'PROVISIONING';
        });

        this.menuService.area.subscribe((area) => {
            let doUpdate = false;
            if (this.area !== area) {
                doUpdate = true;
            }
            this.area = area;
            this.open = this.area.length > 0;
            if (doUpdate) {
                this.updateAppNavigator();
            }
        });

        this.menuService.navItemChanged.subscribe((navItem) => {
            this.selectedNavItem = navItem;
        });

        this.apiService.currentSubscription.subscribe((subscription) => {
            this.currentSubscription = subscription;
            this.isSelfService = this.featureService.isSelfServiceAccount(subscription);
            this.selfServiceBilling = this.isSelfService && this.authorizationService.canViewPaymentProfile();

            if (
                this.featureService.isSelfServiceTeamsTier(subscription) ||
                this.featureService.isSelfServicePAYG(subscription)
            ) {
                this.isSelfServiceTeamsTier = true;
            }
        });
        this.networkServiceV2._networks.subscribe((networks) => {
            this.allNetworks = networks;
        });

        if (this.environment.realmsSupported) {
            ORGANIZATION_NAVIGATOR.groups.forEach((group) => {
                group.menuItems.forEach((item) => {
                    if (item.id === 'org-settings-new') {
                        item.czV8Only = false;
                    } else if (item.id === 'org-settings') {
                        item.czV8Only = true;
                    }
                });
            });
        }
    }

    updateAppNavigator() {
        switch (this.area) {
            case 'Network':
                if (this.featureService.isCloudZiti) {
                    this.currentNav = ZAC_NAVIGATOR;
                } else {
                    this.currentNav = NETWORKS_NAVIGATOR;
                }
                break;
            case 'Infrastructure':
                this.currentNav = ZAC_NAVIGATOR;
                break;
            case 'ZAC':
                this.currentNav = ZAC_NAVIGATOR;
                break;
            case 'Frontdoor':
                this.currentNav = FRONTDOOR_NAVIGATOR;
                break;
            case 'FD':
                this.currentNav = FD_NAVIGATOR;
                break;
            case 'Support_Operations':
                this.currentNav = SUPPORT_OPERATIONS_NAVIGATOR;
                break;
            case 'Organization':
                this.currentNav = ORGANIZATION_NAVIGATOR;
                break;
            case 'Billing':
                this.currentNav = BILLING_NAVIGATOR;
                break;
            case 'Customers':
                this.currentNav = CUSTOMERS_NAVIGATOR;
                break;
            case 'Support':
                this.currentNav = SUPPORT_NAVIGATOR;
                break;
            case 'Super':
                this.currentNav = SUPER_NAVIGATOR;
                break;
            case 'On_Prem':
                this.currentNav = ON_PREM_NAVIGATOR;
                break;
            case 'MOP':
            default:
                if (isEmpty(this.currentNav)) {
                    this.currentNav = ZAC_NAVIGATOR;
                }
                break;
        }
        if (this.currentNav.app && this.area !== '') {
            this.menuService.setApp(this.currentNav.app);
        }
        this.updateSelectedNavItem();
    }

    updateSelectedNavItem() {
        const url = this.router.url.split(';')[0].split('?')[0];
        this.currentNav.groups.forEach((group: any) => {
            group.menuItems.forEach((item: any) => {
                if (item.route === url || item.selectedRoutes?.includes(url)) {
                    this.selectedNavItem = item;
                }
            });
        });
    }

    initNetworks() {
        this.networkServiceV2.getNetworks({ pageParams: { size: 2000, page: 0 } }).then((networks: any) => {
            this.upgradeableNetworks = 0;
            this.networksV7 = networks.map((nw: NetworkV2) => {
                if (this.area === 'Network') {
                    if (this.networkUpgradeService.isUpgradeable(nw)) {
                        this.upgradeableNetworks++;
                    }
                }
                return this.apiService.getNetworkModel(nw);
            });
            this.networkServiceV2._networks.next(this.networksV7);
            this.currentNav.groups.forEach((group: any) => {
                group.menuItems.forEach((item: any) => {
                    if (item.route === URLS.NETWORKS_COMBINED || item.route === INFRASTRUCTURE_URLS.NETWORKS) {
                        item.badgeCount = this.upgradeableNetworks;
                    }
                });
            });
            this.allNetworks = this.networksV7;
            if (this.allNetworks.length < 1 && !this.currentNetwork.isPlaceholder) {
                this.currentNetwork = new Network({});
                this.currentNetwork.name = 'Select A Network';
                this.currentNetwork.isPlaceholder = true;
                this.apiService.setCurrentNetwork(this.currentNetwork);
            }
        });
    }

    navigateToRoute(item: any) {
        if (this.disableMainNav && item.requiresProvision) {
            return;
        }
        this.router.navigate([item.route]);
        this.menuService.setNavItem(item);
    }

    isNavItemDisabled(item: any) {
        return (
            (this.disableMainNav && item.requiresProvision) ||
            (isEmpty(this.currentNetwork?.id) && item.requiresNetwork) ||
            (item.requiresAgent && this.requiresAgent)
        );
    }

    loadTenants() {
        if (this.authorizationService.canListTenants()) {

        const params: any = {};
        this.iamService.find('organizations', params).subscribe((tenants) => {
          this.tenants = tenants
          if (isEmpty(this.organizationId)) {
            this.organizationId = localStorage.getItem('organizationId');
          }
          for (const organization of this.organizations) {
            this.organizationMap[organization.id] = organization;
          }
          this.currentOrganization = this.organizationMap[this.organizationId];
          this.organizationId = this.currentOrganization?.id;
          this.apiService.availableOrganizations.next(this.organizations);
        });
        }
    }

    loadOrganizations() {
        if (this.authorizationService.canListTenants()) {
            this.apiService.availableOrganizations.subscribe((organizations) => {
                this.organizations = organizations as Organization[];

                for (const organization of this.organizations) {
                    this.organizationMap[organization.id] = organization;
                }
                this.currentOrganization = this.organizationMap[this.tenantId] || this.currentOrganization;
                this.organizationId = this.currentOrganization?.id;
            });
        }
    }

    loadCustomers() {
        if (this.authorizationService.canListCustomers()) {
            this.customerService.findCustomersProfiles().then((customers) => {
                this.customers = customers as Customer[];
                if (!this.currentCustomer) {
                    this.currentCustomer = this.customers[0];
                    this.apiService.setCurrentCustomer(this.currentCustomer);
                    this.customerId = this.currentCustomer.id;
                }
                if (this.authorizationService.isSupportUser()) { // support and superuser can see all customers
                    this.customers.push({ id: '', name: '--No Parent--' });
                }
                this.apiService.setParentCustomerList(this.customers);
            });

        }
    }

    loadShares(tenantId?: string) {
        const orgId = tenantId || localStorage.getItem('tenantId');
        if (!orgId) {
            return;
        }
        this.agentService.getAccountById(orgId).subscribe({
            next: (accountData: any) => {
                this.frontdoorId = accountData.id;
                this.isV2 = accountData.version !== 1;
                this.frontdoorReady$.next();

                this.agentService.getAgentsByEnv(this.frontdoorId, this.isV2).subscribe({
                    next: (agentData: any) => {
                        this.envs = agentData?._embedded?.environmentList;
                        // Assign both ways. Latching this to true left the whole nav
                        // disabled after any transient empty result or org switch.
                        this.requiresAgent = isEmpty(this.envs);
                    },
                    error: (err) => {
                        this.logger.error('loadShares: getAgentsByEnv failed', err);
                    }
                });
            },
            error: (err) => {
                this.logger.error('loadShares: getAccountById failed', err);
            }
        });
    }

    addNetwork() {
        this.dialogRef = this.dialogForm.open(V2NetworkCreationFormComponent, {
            minHeight: '100%',
            minWidth: '100%',
            height: '100%',
            width: '100%',
        });
    }

    addFrontdoor() {
        this.router.navigate(['/frontdoor/create']);
    }

    addTenant() {
        this.dialogRef = this.dialogForm.open(OrganizationPromptComponent, {
            data: {},
            height: '475px',
            width: '855px',
            autoFocus: false,
        });
        this.dialogRef.afterClosed().subscribe(() => {
            this.loadTenants();
        });
    }

    openTicket() {
        this.dialogRef = this.dialogForm.open(TicketFormComponent, {
            data: {},
            height: '695px',
            width: '975px',
            autoFocus: false,
        });
    }

    openSupport() {
        this.zendeskService.zE('webWidget', 'show');
        this.zendeskService.zE('webWidget', 'open');
    }

    openTour() {
        this.dialogRef = this.dialogForm.open(ConsoleTourComponent, {
            data: {},
            height: '455px',
            width: '935px',
            autoFocus: false,
        });
    }
}
